import { useRef, useEffect, useState, useCallback, ChangeEvent } from 'react'
import { startSxpProxy } from '../../utils/api'
import '../membership/membership.scss'
import {
  AB_MEMBERHSIP_PROJECT_ID,
  ODOO_COGNITIVECARE_INVOICE,
  pageSizeOptions,
} from '../../utils/constants'
import { useAppDispatch, useAppSelector } from '../../app/hooks'
import { selectSelectedLocationId } from '../location/locationSlice'
import { NavLink, useNavigate } from 'react-router-dom'
import { MEMBERSHIP_UPDATE } from '../../utils/roles'
import KeycloakService from '../../utils/keycloakService'
import MaskedNumber from '../../components/MaskedNumber'
import ProvenanceView from '../../components/ProvenanceView'
import { create } from '../lms/constants'
import MembershipSearch from '../membership/MembershipSearch'
import {
  selectQuery,
  selectParam,
  setQueryParam,
} from '../membership/membershipSlice'
import {
  PaginateModel,
  MembershipModel,
  consumption,
} from '../membership/models'
import {
  ABmembership,
  ABMembershipIntent,
  active,
  AyuvuBharosa,
  enterMobile,
  enterText,
  membershipCreate,
  MemeberStatus,
  noinvoice,
  paidTitleCaseString,
  resize,
  Status,
  waiting,
} from './constants'
import {
  ABMemberDashboard,
  editABMembership,
} from '../bedManagement/endpoints/EndPoints'
import { toast } from 'react-toastify'
import CustomHeader from '../Radiology/components/RadiologyModel/CustomHeader'
import { ColDef } from 'ag-grid-community'
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  IconButton,
  Tooltip,
  useTheme,
} from '@mui/material'
import MedAgDataGrid from '../../components/MedAgDataGrid'
import useCustomStyles from '../../utils/hooks/CustomStylesHook'
import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import PrintIcon from '@mui/icons-material/Print'
const styles = () => ({
  patientheading: {
    color: '#090968',
    fontSize: '16px',
    fontWeight: 600,
  },
  deviceText: {
    color: '#090968',
    fontSize: '16px',
    fontWeight: 600,
  },
  centerHeader: {
    color: '#ffffff',
    textAlign: 'center',
    '& .ag-header-cell-text': {
      flex: 1,
    },
  },
  abMembershipMainContainer: {
    width: '100%',
    height: '100%',
    padding: '0.5rem',
  },
  abMembershipSubContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  editIcon: {
    width: '18px',
  },
  calendarMonthIcon: {
    color: '#625e5e !important',
    width: '22px',
    height: '20px',
  },
  unpaidLink: {
    textTransform: 'initial',
    outline: 'border-box',
    background: '#E35335',
    color: 'white',
    padding: '0px 2px',
    fontSize: '10px',
    '&:hover': {
      background: '#E35335',
    },
  },
  paidLink: {
    textTransform: 'initial',
    outline: 'border-box',
    background: 'green',
    color: 'white',
    padding: '0px 2px',
    fontSize: '10px',
    '&:hover': {
      background: 'green',
    },
  },
  otherLink: {
    textTransform: 'initial',
    outline: 'border-box',
    background: 'skyblue',
    color: 'white',
    padding: '0px 2px',
    fontSize: '10px',
    '&:hover': {
      background: 'skyblue',
    },
  },
  endIcon: {
    fontSize: '13px !important',
  },
  printIcon: {
    width: '20px',
    height: '20px',
  },
  waitingContent: {
    fontSize: '12px',
    color: 'black',
    background: 'skyblue',
    borderRadius: '8px',
    padding: '2px 7px 2px 7px',
  },
  activeContent: {
    fontSize: '12px',
    color: 'black',
    background: '#a5e7a5',
    borderRadius: '8px',
    padding: '2px 7px 2px 7px',
  },
  referrerInfo: {
    cursor: 'pointer',
    textDecoration: 'underline',
  },
  noReferrer: {
    color: '#1976d2',
  },
  yesReferrer: {
    color: 'black',
  },
})
import PremiumCalculator from './PremiumCalculator'
import { ReactComponent as PieLogo } from '../../assets/icons/pieChart.svg'
import AttachFileIcon from '@mui/icons-material/AttachFile'
import UploadAbDocs from './UploadAbDocs'
import { handleSubmitReferrerEdit } from '../../services/MembershipDetailsService'
import ReferrerDetails from './ReferrerDetails'
import EditNoteIcon from '@mui/icons-material/EditNote'
const ABMembershipDashboard = () => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)
  const query = useAppSelector(selectQuery)
  const param = useAppSelector(selectParam)
  const dispatch = useAppDispatch()
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()
  const [currentPage, setCurrentPage] = useState(1)
  const [isOpenDocsPage, setIsOpenDocsPage] = useState(false)
  const [selectedPatientId, setSelectedPatientId] = useState<string>('')
  const [selectedMuhId, setSelectedMuhId] = useState<string>('')
  const [limit, setLimit] = useState(100)
  const [paginate, setPaginate] = useState<PaginateModel>({
    totalCount: 0,
    totalPages: 0,
    data: [],
  })
  const [memberships, setMemberships] = useState<MembershipModel[]>([])
  const [openCalculator, setOpenCalculator] = useState(false)
  const [editDialogOpen, setEditDialogOpen] = useState(false)
  const [selectedReferrerData, setSelectedReferrerData] = useState<any>(null)
  const [referrerName, setReferrerName] = useState('')
  const [referrerMobile, setReferrerMobile] = useState('')
  const handleOpenCalculator = () => {
    setOpenCalculator(true)
  }

  const handleCloseCalculator = () => {
    setOpenCalculator(false)
  }

  const filteredMemberships = memberships?.filter(
    (e) => e?.partner?.ref !== false
  )
  const handleEditReferrerClick = (params: any) => {
    const data = params.data
    setSelectedReferrerData(data)
    setReferrerName(data?.refferer || '')
    setReferrerMobile(data?.refferer_phone || '')
    setEditDialogOpen(true)
  }

  const handleCloseEditDialog = () => {
    setEditDialogOpen(false)
    setSelectedReferrerData(null)
    setReferrerName('')
    setReferrerMobile('')
  }

  const handleSubmitReferrer = async () => {
    const response = await handleSubmitReferrerEdit(
      selectedReferrerData,
      referrerName,
      referrerMobile
    )
    if (response?.success) {
      toast.success(response?.message, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
      })

      // Reload the table data
      setLoading(true)
      getMemberships(query, param)

      handleCloseEditDialog()
    } else {
      toast.error(response?.message, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
      })
    }
  }
  const location = useAppSelector(selectSelectedLocationId)
  const handlePageChange = (newPage: any) => {
    setCurrentPage(newPage)
  }

  useEffect(() => {
    setCurrentPage(1)
  }, [limit, paginate.totalCount])
  const getMemberships = useCallback(
    (q: any, p: any) => {
      const state = {
        location,
        [q]: p,
        limit: limit,
        offset: (currentPage - 1) * limit,
        membershipType: AyuvuBharosa,
      }
      startSxpProxy(
        AB_MEMBERHSIP_PROJECT_ID,
        ABMembershipIntent?.abMembershipLines,
        state
      )
        ?.then((data) => {
          setPaginate({
            totalCount: data?.data?.total_count,
            totalPages: data?.data?.total_pages,
            data: data?.data?.data,
          })
          const members: MembershipModel[] = data?.data?.data ?? []
          setMemberships(members)
        })
        ?.catch((err) => {
          console?.log(err)
          setMemberships([])
          setPaginate({
            totalCount: 0,
            totalPages: 0,
            data: [],
          })
        })
        ?.finally(() => setLoading(false))
    },
    [location, currentPage, limit]
  )
  const index = (currentPage - 1) * limit
  const startIndex = index + 1
  const endIndex = Math?.min(index + limit, paginate?.totalCount)
  useEffect(() => {
    setLoading(true)
    getMemberships(query, param)
  }, [getMemberships, query, param])

  const membershipTableContainerRef = useRef<HTMLDivElement | null>(null)
  useEffect(() => {
    const resizeHandler = () => {
      const container = membershipTableContainerRef.current
      if (container) {
        const availableHeight: any =
          window.innerHeight - container?.getBoundingClientRect().top
        container.style.maxHeight = `${availableHeight - 60}px`
      }
    }
    window.addEventListener(`${resize}`, resizeHandler)
    resizeHandler()
    return () => {
      window.removeEventListener(`${resize}`, resizeHandler)
      dispatch(setQueryParam({ q: '', param: '' }))
    }
  }, [dispatch])

  const handleCreateMembership = () => {
    navigate(`${membershipCreate}`)
  }

  const onEdit = (id: any) => {
    navigate(`${editABMembership}/${id}`)
  }
  const statusFunction = (id: string) => {
    switch (id) {
      case `${Status?.paid}`:
        return `${MemeberStatus?.paid}`
      case `${Status?.none}`:
        return `${MemeberStatus?.none}`
      case `${Status?.waiting}`:
        return `${MemeberStatus?.waiting}`
      case `${Status?.invoiced}`:
        return `${MemeberStatus?.invoiced}`
      case `${Status?.canceled}`:
        return `${MemeberStatus?.canceled}`
      case `${Status?.old}`:
        return `${MemeberStatus?.old}`
      default:
        return '-'
    }
  }

  const handleSizeChange = (e: ChangeEvent<HTMLSelectElement>) => {
    setLimit(Number(e?.target?.value))
  }
  const handleInvoiceClick = (id: any) => {
    if (id) {
      window.open(`${ODOO_COGNITIVECARE_INVOICE}/${id}`, '_blank')
    } else {
      toast.error(noinvoice, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
      })
    }
  }

  const handlePaidLink = (params: any) => {
    const d = params?.data
    return (
      <div>
        <Button
          onClick={() => handleInvoiceClick(d?.cognitivecare_invoice_id)}
          endIcon={<OpenInNewIcon className={classes?.endIcon} />}
          className={
            d?.cognitivecare_payment_status === paidTitleCaseString
              ? classes?.paidLink
              : classes?.otherLink
          }
        >
          {d?.cognitivecare_payment_status === paidTitleCaseString
            ? paidTitleCaseString
            : d?.cognitivecare_payment_status}
        </Button>
      </div>
    )
  }
  const invoicePrint = (params: any) => {
    const d = params?.data
    return (
      <div
        onClick={() => handleInvoiceClick(d?.cognitivecare_invoice_id)}
        className='text-center'
      >
        <PrintIcon titleAccess='Print Report' className={classes?.printIcon} />
      </div>
    )
  }
  const editAction = (params: any) => {
    const d = params?.data

    const handleMembershipConsumptionClick = (id: any) => {
      navigate(`/ab/membershipDetails/${id}`, {
        state: { source: consumption },
      })
    }

    return (
      <Box display={'flex'} justifyContent={'space-around'}>
        <Tooltip title='Edit Ab Membership'>
          <IconButton
            size='small'
            onClick={
              KeycloakService.hasRole([MEMBERSHIP_UPDATE])
                ? () => onEdit(d?.id)
                : undefined
            }
            disabled={!KeycloakService.hasRole([MEMBERSHIP_UPDATE])}
            className={`custom-btn custom-btn-primary ml10 ${
              KeycloakService.hasRole([MEMBERSHIP_UPDATE])
                ? 'cursor-pointer'
                : 'auth-disabled cursor-default'
            }`}
          >
            <EditNoteIcon
              fontSize='small'
              className={classes?.calendarMonthIcon}
            />
          </IconButton>
        </Tooltip>

        <Tooltip title='Member Benifit Consumption'>
          <IconButton
            size='small'
            onClick={() => handleMembershipConsumptionClick(d?.partner?.ref)}
          >
            <PieLogo width={20} height={20} />
          </IconButton>
        </Tooltip>
      </Box>
    )
  }
  const renderPolicyStatus = (text: string) => {
    return text === active ? (
      <span className={classes?.activeContent}>Active</span>
    ) : text === waiting ? (
      <span className={classes?.waitingContent}>Waiting</span>
    ) : (
      text
    )
  }
  const handleDocClick = (patientId: string, muhid: string) => {
    setIsOpenDocsPage(true)
    setSelectedPatientId(patientId)
    setSelectedMuhId(muhid)
  }
  const handleCloseDialog = () => {
    setIsOpenDocsPage(false)
  }
  const handlePatientDocuments = (params: any) => {
    const d = params?.data
    return (
      <div
        onClick={() =>
          handleDocClick(d.patient_registered_id, d?.partner?.ref ?? '')
        }
        className='uploadbtn text-center'
      >
        <AttachFileIcon fontSize='small' />
      </div>
    )
  }
  const columnDefs: ColDef[] = [
    {
      headerName: 'SL No',
      field: 'slNo',
      width: 80,
      sortable: false,
      filter: false,
      cellRenderer: (params: any) =>
        (currentPage - 1) * limit + (params?.node?.rowIndex + 1),
      headerClass: 'custom-header-cell',
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
      resizable: false,
      pinned: 'left',
      lockPinned: true,
    },
    {
      headerName: 'Policy ID',
      field: 'name',
      minWidth: 140,
      sortable: false,
      filter: false,
      cellRenderer: (params: any) => (
        <NavLink to={`${ABMemberDashboard}${params?.data?.id}`}>
          {params?.data?.name}
        </NavLink>
      ),
      headerClass: 'custom-header-cell',
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'left' },
      resizable: false,
      pinned: 'left',
      lockPinned: true,
    },
    {
      headerName: 'Policy Name',
      field: 'policyName',
      minWidth: 220,
      sortable: false,
      filter: false,
      cellRenderer: (params: any) => params?.data?.membership_id?.[1],
      headerClass: 'custom-header-cell',
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
      resizable: false,
      pinned: 'left',
      lockPinned: true,
    },
    {
      headerName: 'Customer Reference',
      field: 'name',
      minWidth: 150,
      sortable: false,
      filter: false,
      headerComponent: CustomHeader,
      cellRenderer: (params: any) => params?.data?.partner?.ref ?? '-',
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
      resizable: false,
      pinned: 'left',
      lockPinned: true,
    },
    {
      headerName: 'Policy Holder',
      field: 'primary',
      minWidth: 250,
      sortable: true,
      filter: true,
      cellRenderer: (params: any) => params?.data?.partner?.name ?? '-',
      headerComponent: CustomHeader,
      headerClass: classes?.centerHeader,
      cellClass: 'custom-header-cell',
      cellStyle: {
        fontSize: '12px',
        textAlign: 'left',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        lineHeight: 1.2,
        display: 'flex',
        alignItems: 'center',
      },
      wrapText: true,
      autoHeight: true,
      resizable: false,
      pinned: 'left',
      lockPinned: true,
    },
    {
      headerName: 'Age',
      field: 'partner_age',
      minWidth: 80,
      sortable: false,
      filter: false,
      cellRenderer: (params: any) => params?.data?.partner_age ?? 0,
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'Gender',
      field: 'partner_gender',
      minWidth: 105,
      sortable: true,
      filter: true,
      cellRenderer: (params: any) => params?.data?.partner_gender ?? '-',
      headerComponent: CustomHeader,
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },

    {
      headerName: 'Mobile',
      field: 'mobile',
      minWidth: 130,
      sortable: false,
      filter: true,
      headerComponent: CustomHeader,
      cellRenderer: (params: any) =>
        params?.data?.partner?.phone ? (
          <MaskedNumber mobile={params?.data?.partner?.phone} />
        ) : (
          '-'
        ),
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'Premium Amount',
      field: 'cognitivecare_premium_amount',
      minWidth: 140,
      sortable: false,
      filter: false,
      cellRenderer: (params: any) =>
        params?.data?.cognitivecare_premium_amount ?? '-',
      headerClass: 'custom-header-cell',
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'Discount',
      field: 'discount',
      minWidth: 100,
      sortable: false,
      filter: false,
      cellRenderer: (params: any) => params?.data?.discount ?? 0,
      headerClass: 'custom-header-cell',
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'Insured Amount',
      field: 'sum_insured',
      minWidth: 140,
      sortable: false,
      filter: false,
      cellRenderer: (params: any) => params?.data?.sum_insured ?? 0,
      headerClass: 'custom-header-cell',
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'Member Type',
      field: 'state',
      minWidth: 140,
      sortable: false,
      filter: false,
      cellRenderer: (params: any) =>
        params?.data?.state ? statusFunction(params?.data?.state) : '-',
      headerClass: 'custom-header-cell',
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'Policy Start Date',
      field: 'date_from',
      minWidth: 140,
      sortable: false,
      filter: false,
      cellRenderer: (params: any) => params?.data?.date_from ?? 0,
      headerClass: 'custom-header-cell',
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'Policy Expiry Date',
      field: 'date_to',
      minWidth: 140,
      sortable: false,
      filter: false,
      cellRenderer: (params: any) => params?.data?.date_to ?? 0,
      headerClass: 'custom-header-cell',
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'Days To Expire',
      field: 'days_to_expire',
      minWidth: 100,
      sortable: false,
      filter: false,
      cellRenderer: (params: any) => params?.data?.days_to_expire ?? 0,
      headerClass: 'custom-header-cell',
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'Policy Status',
      field: 'policy_status',
      minWidth: 130,
      sortable: false,
      filter: false,
      cellRenderer: (params: any) =>
        renderPolicyStatus(params?.data?.policy_status) ?? '-',
      headerClass: 'custom-header-cell',
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'Invoice No',
      field: 'Cognitivecare_invoice_no',
      minWidth: 140,
      sortable: false,
      filter: false,
      cellRenderer: (params: any) =>
        params?.data?.cognitivecare_invoice_no === false
          ? '-'
          : params?.data?.cognitivecare_invoice_no,
      headerClass: 'custom-header-cell',
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'Payment Status',
      field: 'cognitivecare_payment_status',
      minWidth: 140,
      sortable: false,
      filter: false,
      cellRenderer: (params: any) =>
        params?.data?.cognitivecare_payment_status === false
          ? '-'
          : handlePaidLink(params),
      headerClass: 'custom-header-cell',
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'Payment Date',
      field: 'cognitivecare_payment_date',
      minWidth: 140,
      sortable: false,
      filter: false,
      cellRenderer: (params: any) =>
        params?.data?.cognitivecare_payment_date === false
          ? '-'
          : params?.data?.cognitivecare_payment_date,
      headerClass: 'custom-header-cell',
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'Payment Mode',
      field: 'cognitivecare_payment_mode',
      minWidth: 140,
      sortable: false,
      filter: false,
      cellRenderer: (params: any) =>
        params?.data?.cognitivecare_payment_mode === false
          ? '-'
          : params?.data?.cognitivecare_payment_mode,
      headerClass: 'custom-header-cell',
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'No Of Adults',
      field: 'adult',
      minWidth: 105,
      sortable: false,
      filter: false,
      cellRenderer: (params: any) => params?.data?.adult ?? 0,
      headerClass: 'custom-header-cell',
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'No Of Child',
      field: 'child',
      minWidth: 105,
      sortable: false,
      filter: false,
      cellRenderer: (params: any) => params?.data?.child ?? 0,
      headerClass: 'custom-header-cell',
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },

    {
      headerName: 'Member Id',
      field: 'member_id',
      minWidth: 140,
      sortable: false,
      filter: false,
      cellRenderer: (params: any) => params?.data?.member_id ?? '-',
      headerClass: 'custom-header-cell',
      cellClass: 'custom-header-cell',
      cellStyle: { fontSize: '12px', textAlign: 'center' },
    },
    {
      headerName: 'Contact Address',
      field: 'contact_address',
      minWidth: 200,
      sortable: true,
      filter: true,
      cellRenderer: (params: any) => params?.data?.contact_address || '-',
      headerComponent: CustomHeader,
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: {
        fontSize: '12px',
        textAlign: 'left',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        lineHeight: 1.1,
        display: 'flex',
        alignItems: 'center',
      },
      wrapText: true,
      autoHeight: true,
    },

    {
      headerName: 'Referrer',
      field: 'refferer',
      minWidth: 200,
      sortable: true,
      filter: true,
      cellRenderer: (params: any) => (
        <Tooltip title='Click to edit referrer information'>
          <span
            className={`${classes?.referrerInfo} ${
              params?.data?.refferer === false
                ? classes?.noReferrer
                : classes?.yesReferrer
            }`}
            onClick={() => handleEditReferrerClick(params)}
          >
            {params?.data?.refferer === false
              ? enterText
              : params?.data?.refferer}
          </span>
        </Tooltip>
      ),
      headerComponent: CustomHeader,
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: {
        fontSize: '12px',
        textAlign: 'left',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        display: 'flex',
        alignItems: 'center',
        lineHeight: 1,
      },
      wrapText: true,
    },
    {
      headerName: 'Referrer Mobile',
      field: 'mobile',
      minWidth: 130,
      sortable: true,
      filter: true,
      cellRenderer: (params: any) => (
        <Tooltip title='Click to edit referrer information'>
          <span
            className={`${classes?.referrerInfo} ${
              params?.data?.refferer_phone === false
                ? classes?.noReferrer
                : classes?.yesReferrer
            }`}
            onClick={() => handleEditReferrerClick(params)}
          >
            {params?.data?.refferer_phone === false
              ? enterMobile
              : params?.data?.refferer_phone}
          </span>
        </Tooltip>
      ),
      headerComponent: CustomHeader,
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: {
        fontSize: '12px',
        textAlign: 'left',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        display: 'flex',
        alignItems: 'center',
        lineHeight: 1,
      },
      wrapText: true,
    },
    {
      headerName: 'CC Invoice',
      field: 'ccInvoice',
      flex: 1,
      minWidth: 120,
      sortable: true,
      filter: true,
      cellRenderer: invoicePrint,
      headerComponent: CustomHeader,
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: {
        fontSize: '12px',
        textAlign: 'center',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        display: 'flex',
        justifyContent: 'center',
        lineHeight: 1.5,
      },
      wrapText: true,
    },
    {
      headerName: 'Documents',
      field: 'documents',
      minWidth: 100,
      sortable: true,
      filter: true,
      cellRenderer: handlePatientDocuments,
      headerComponent: CustomHeader,
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: {
        fontSize: '12px',
        textAlign: 'center',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        lineHeight: 1,
      },
      wrapText: true,
    },
    {
      headerName: 'Action',
      field: 'edit',
      flex: 1,
      minWidth: 80,
      sortable: true,
      filter: false,
      cellRenderer: editAction,
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: {
        fontSize: '12px',
        textAlign: 'center',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        display: 'flex',
        justifyContent: 'center',
        lineHeight: 1.5,
      },
      wrapText: true,
    },
    {
      headerName: 'Created By',
      field: 'CreatedBy',
      minWidth: 200,
      sortable: true,
      filter: true,
      cellRenderer: (params: any) => (
        <ProvenanceView
          mode={create}
          date={params?.data?.account_invoice_id?.invoice_date_time ?? ''}
          name={params?.data?.account_invoice_id?.thop_user_name ?? ''}
        />
      ),
      headerComponent: CustomHeader,
      cellClass: 'custom-header-cell',
      headerClass: 'custom-header-cell',
      cellStyle: {
        fontSize: '12px',
        textAlign: 'left',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        display: 'flex',
        alignItems: 'center',
        lineHeight: 1,
      },
      wrapText: true,
    },
  ]
  return (
    <>
      <Dialog
        open={editDialogOpen}
        onClose={handleCloseEditDialog}
        maxWidth='sm'
        fullWidth
      >
        <ReferrerDetails
          referrerName={referrerName}
          referrerMobile={referrerMobile}
          setReferrerName={setReferrerName}
          setReferrerMobile={setReferrerMobile}
          onClose={handleCloseEditDialog}
          onSubmitReferrer={handleSubmitReferrer}
        />
      </Dialog>
      <div className={classes?.abMembershipMainContainer}>
        <Dialog
          open={openCalculator}
          onClose={handleCloseCalculator}
          maxWidth='xl'
          fullWidth
        >
          <PremiumCalculator />
        </Dialog>
        <div className={classes?.abMembershipSubContainer}>
          <div className='membership-dashboard-text'>{ABmembership}</div>
        </div>
        <Box height={'96%'} width={'100%'} marginTop={'-27px'}>
          <MedAgDataGrid
            tableHeight={'100%'}
            rowData={filteredMemberships}
            columnDefs={columnDefs}
            pagination={false}
            searchField={false}
            headerHeight={30}
            rowHeight={40}
            exportIcon={false}
            globalSearch={
              <MembershipSearch
                onCreate={handleCreateMembership}
                onPremiumCalculate={handleOpenCalculator}
                memberships={filteredMemberships}
              />
            }
            localSearch={false}
            enableCellTextSelection={true}
            loading={loading ? true : false}
          />
        </Box>
        <div className='text-right pagination-main-content'>
          <div className='inline-block membership-pagination text-right'>
            <select
              className='rowsperpage pagination-container'
              defaultValue={limit}
              onChange={handleSizeChange}
            >
              {pageSizeOptions?.map((size: number) => (
                <option key={size}>{size}</option>
              ))}
            </select>
            <span>
              <span className='mr10 pagination-container'>
                {startIndex}-{endIndex}/{paginate?.totalCount}{' '}
              </span>
            </span>
          </div>

          <div className='pagination-count-content'>
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              className={`icon-disable-btn ${
                currentPage !== 1 ? '' : 'disableBtn'
              }`}
              disabled={currentPage === 1}
            >
              <KeyboardArrowLeft />
            </button>
            <button
              onClick={() => handlePageChange(currentPage + 1)}
              className={`icon-disable-btn ${
                currentPage !== paginate?.totalPages ? '' : 'disableBtn'
              }`}
              disabled={currentPage === paginate?.totalPages}
            >
              <KeyboardArrowRight />
            </button>
          </div>
        </div>
      </div>
      <Dialog open={isOpenDocsPage} onClose={handleCloseDialog} maxWidth='sm'>
        <IconButton onClick={handleCloseDialog} className='flex-end f12'>
          x
        </IconButton>
        <DialogContent className='margin2 padding20'>
          {' '}
          <UploadAbDocs
            patientId={selectedPatientId}
            muhid={selectedMuhId}
          />{' '}
        </DialogContent>
      </Dialog>
    </>
  )
}

export default ABMembershipDashboard
